import React from 'react';
import { Linkedin } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-[#1a1c1b] border-t border-[var(--border-light)]">
      <div className="container-custom mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          <div className="lg:w-1/2">
             <h2 className="heading-2 mb-8">The Throughline</h2>
             <p className="heading-5 text-[var(--brand-primary)] mb-8">
               "Mindset over skillsets and toolsets with stories, metaphors and analogies to move people from left brain to right brain."
             </p>
             <div className="space-y-6 text-gray-300 body-medium">
                <p>
                  From sweeping factory floors to running a 100,000 sq ft data center, and even discussing sustainability with the King of Spain—My unique perspectives is forged in the fires of a wide set of experiences spanning front of house, back of house and out of house across technologies, industry verticals, business models and team dynamics.
                </p>
                <p>
                  My path is intentionally nonlinear: railroad brakeman/switchman, machinist, forklift and truck driver, warehouse, retail clerk - to a world ranked three cushion billiards player, then executive leadership roles across Lenovo, Oracle, HP, Unisys, Novell, Infor, and Phoenix Technologies. I have also have the scar tissue from nine startups from seed to IPOs and buyouts.
                </p>
                <p>
                  Some official and unofficial titles that I held; CTO, Distinguished Technologist, Free Range Chicken, Poker of Bears and Kicker of Hornets nest.
                </p>
             </div>
          </div>
          <div className="lg:w-1/2 relative">
             <div className="border border-[var(--brand-primary)] p-2 rounded-2xl relative z-10 bg-[#1a1c1b]">
                <img 
                    src="https://customer-assets.emergentagent.com/job_speak-delivery/artifacts/dfig84k3_shc%2010.jpg" 
                    alt="Professional Speaker Profile" 
                    className="w-full h-auto rounded-xl grayscale hover:grayscale-0 transition-all duration-500"
                />
             </div>
             
             {/* LinkedIn Link */}
             <div className="mt-6 flex justify-center lg:justify-start relative z-10">
                <a 
                    href="https://www.linkedin.com/in/edsoohoo/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-[var(--brand-primary)] hover:bg-[var(--brand-primary)] hover:text-[#1a1c1b] transition-all duration-300 uppercase font-bold tracking-wider border border-[var(--brand-primary)] px-8 py-3 rounded-full group"
                >
                    <Linkedin size={20} className="group-hover:stroke-black" />
                    <span>Connect on LinkedIn</span>
                </a>
             </div>

             {/* Decorative element behind image */}
             <div className="absolute top-10 -right-10 w-full h-full border-2 border-[var(--secondary-olive)] rounded-2xl -z-0 hidden md:block"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
